// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","Bluecheese":"#615CFF","Oyster":"#C0C5C9","mainText":"G9f10ee","link":"G29b76a Gc3ece6"};